export class ConcurrenceTime {
    static DISABLED = -1;
    static WITHOUT_TIME = 9999;
    static SAME_DAY = 0;
    static ONE_DAY = 1;
    static SEVEN_DAYS = 7;
    static FIFTEEN_DAYS = 15;
    static ONE_MONTH = 30;
    static TWO_MONTH = 60;
    static THREE_MONTH = 90;
    static FOUR_MONTH = 120;
    static FIVE_MONTH = 150;
    static SIX_MONTH = 180;
    static ONE_YEAR = 365;
}
